// ============================================================================
//  supabaseClient.js  —  browser-side Supabase client (Realtime only)
// ============================================================================
//
//  This client is used ONLY for Realtime subscriptions in the UI — every
//  mutation still flows through Azure Functions endpoints under Entra auth.
//  The publishable key is intentionally exposed to the browser, so it must
//  NEVER be able to read business data. Since 2026-10-07 (schema-059) the
//  only thing it can read is realtime_signals — a data-free "tips changed"
//  timestamp. Components subscribe to that and re-fetch through the
//  authenticated API. Do NOT add anon SELECT policies on data tables.
//
//  Pattern: subscribe on mount, unsubscribe on unmount. See Review.jsx.
// ============================================================================

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
  || 'https://llrngvcfyzbwuvuuefgf.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  || 'sb_publishable_6xoIIdE9mS3lA8v-yAaLJg_Cf6Vi0Tw';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: { persistSession: false },                  // we use Entra, not Supabase auth
  realtime: { params: { eventsPerSecond: 10 } }
});
